export const PRIVILEGES = {
    GARDENING_SUPER: "Garðyrkja super",
    GARDENING: "Garðyrkja",
    MOWING_SUPER: "Sláttur super",
    MOWING: "Sláttur",
    WINTER_WORK_SUPER: "Vetrarverk super",
    WINTER_WORK: "Vetrarverk",
    TIME_CLOCK_SUPER: "Stimpilklukka super",
    TIME_CLOCK: "Stimpilklukka",
    INSPECTION_SUPER: "Eftirlit super",
    INSPECTION: "Eftirlit",
    VEHICLE_REGISTRATION: "Bilanaskráning",
    WORKSHOP: "Verkstæði",
};

export const SERVICE_TYPES = {
    TRIMMING: "Klipping",
    CLEANING: "Hreinsun",
    GARDENING: "Garðyrkja",
    MOWING: "Sláttur",
    WINTER_WORK: "Vetrarverk",
};

export const SERVICE_SECTIONS = {
    GARDENING: "Garðyrkja",
    WINTER_WORK: "Vetrarverk",
    MOWING: "Sláttur",
}

export const VEHICLE_CONDITIONS = {
    OK: "Í lagi",
    NEEDS_MAINTENANCE: "Þarf að þjónusta",
    BROKEN: "Bilað",
    OUT_OF_SERVICE: "Úr umferð"
};

export const PICKING_LINE_STATUS = {
    I_HILLU: "810360000",
    I_HOLFI: "810360001",
    I_YFIRFERD: "810360002",
    KOMID_I_HILLU: "810360003",
};

export const PICKING_LINE_STATUS_LABEL = {
    "810360000": "Í hillu",
    "810360001": "Í hólfi",
    "810360002": "Tekið til yfirferðar",
    "810360003": 'Komið Í hillu',
};
